module.exports = __webpack_public_path__ + "images/pages/sns_campaign_lp/mainvisual-bg-pc_3281f4b81fa598316cd70fc51b1db710.png";